import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'trigger']
  static values = {
    active: { type: Boolean, default: false },
    ariaLabels: { type: Object }
  }

  toggle(event) {
    // use checkbox state as source of truth if it exists
    const checked = event?.target?.checked

    this.activeValue =
      typeof checked === 'boolean' ? checked : !this.activeValue

    if (this.hasTriggerTarget && this.ariaLabelsValue) {
      this.triggerTarget.ariaLabel = this.activeValue
        ? this.ariaLabelsValue.active
        : this.ariaLabelsValue.inactive
    }

    if (!this.hasContentTarget) return

    this.contentTargets.forEach(
      target => (target.dataset.active = this.activeValue)
    )
  }
}
